import React, {Fragment} from 'react';

import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';


import CloseIcon from '@material-ui/icons/Close';

export class wersja {
    /**  */
    data: string = '';
  
    /**  */
    wersja: string = '';
  
    /**  */
    opis: string = '';
  
    constructor(data?: any) {
      if (data) {
        this['data'] = data['data'];
        this['wersja'] = data['wersja'];
        this['opis'] = data['opis'];
      }
    }
}

type ModalProps = {
    open: boolean,
    historiaWersji: wersja[],
    toggleDialog : () => void,  
}

class Notifier extends React.Component<ModalProps & WithStyles<typeof styles>> {
  
    render() {
      const {classes}  = this.props;
  
      return (
        <Dialog
            maxWidth="xs"
            open={this.props.open}
            onClose={this.props.toggleDialog}
            fullWidth
        >   
            <DialogTitle disableTypography style={{minWidth: "280px", paddingBottom: "0px"}}>
                <Typography variant="h6" component="h2" color="primary">
                    <b>{ "wersja" }</b>
                </Typography>
                <hr />
            </DialogTitle> 
            <DialogContent >
                {/* <AppBar className={classes.appBar}>
                    <Toolbar>
                        <IconButton
                        color="inherit"
                        onClick={this.props.toggleDialog}
                        aria-label="Close"
                        >
                            <CloseIcon />
                        </IconButton>
                        <Typography
                        variant="h6"
                        color="inherit"
                        className={classes.flex}
                        >
                        Wersja
                        </Typography>
                    </Toolbar>
                </AppBar> */}
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell align='left' className={`${classes.cell} ${classes.primary}`}>data</TableCell>
                            <TableCell align='left'className={`${classes.cell} ${classes.primary}`}>wersja</TableCell>
                            <TableCell className={`${classes.cell} ${classes.primary}`}>opis</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {this.props.historiaWersji.map((wersja: wersja, index: any) => (
                            <TableRow key={index}>
                                <TableCell align='left' className={classes.cell} style={{width: "27%"}}>{wersja.data}</TableCell>
                                <TableCell align='left' className={classes.cell}>{wersja.wersja}</TableCell>
                                <TableCell>{wersja.opis}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </DialogContent>
            <DialogActions>
            <Button variant="outlined" color="primary" size="small"
                    onClick={this.props.toggleDialog}>
              <b>OK</b>
            </Button>      
          </DialogActions>
        </Dialog>
      );
    }
  }

  const styles = (theme : Theme) => ({
    appBar: {
        position: 'relative' as 'relative'
    },
    flex: {
        flex: 1
    },
    cell: {
        color: "rgb(85, 85, 85)"
    },
    primary: {
        color: theme.palette.primary.main,
        fontWeight: "bold" as "bold"
    },     
});
  
export default withStyles(styles)(Notifier);